import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useReportSalesGeneral = () => useQuery({ queryKey: [`report-sales-general`], queryFn: async () => {
    const callback = await API.get(`/reports/sales`)
    return callback?.data
}, staleTime: 3000, gcTime: 1000 * 60 * 10 })

export default useReportSalesGeneral